import axios from "axios";
import { API_ROOT } from ".";
import { getAuthUser } from "./auth";
import type { DayOption } from "../components/dashboard/utils/types";
const PICKUP_LOCATIONS_API_URL = `${API_ROOT}/pickup-locations`;

function getAuthHeaders(): { Authorization: string } {
  const token = getAuthUser()?.token;
  if (!token) throw new Error("Not authenticated");
  return { Authorization: `Bearer ${token}` };
}

export interface PickupLocation {
    _id: string;
    name: string;
    address: string;
    latitude: number;
    longitude: number;
    days: DayOption[];
    undeletable?: boolean;
    createdAt?: string;
    updatedAt?: string;
  }

export interface CreatePickupLocationPayload {
    name: string;
    address: string;
    latitude: number;
    longitude: number;
    days: DayOption[];
}

export interface UpdatePickupLocationPayload {
    name?: string;
    address?: string;
    latitude?: number;
    longitude?: number;
    days?: DayOption[];
}

export interface DeletePickupLocationPayload {
    id: string;
}

export async function callFetchPickupLocations(): Promise<PickupLocation[]> {
    const res = await axios.get<PickupLocation[]>(`${PICKUP_LOCATIONS_API_URL}`);
    return res.data;
}

export async function callCreatePickupLocation(data: CreatePickupLocationPayload): Promise<PickupLocation> {
    const res = await axios.post<PickupLocation>(`${PICKUP_LOCATIONS_API_URL}`, data, {
        headers: getAuthHeaders(),
    });
    return res.data;
}

export async function callUpdatePickupLocation(id: string, data: UpdatePickupLocationPayload): Promise<PickupLocation> {
    const res = await axios.put<PickupLocation>(`${PICKUP_LOCATIONS_API_URL}/${id}`, data, {
        headers: getAuthHeaders(),
    });
    return res.data;
}

export async function callDeletePickupLocation(id: string): Promise<void> {
    const res = await axios.delete<void>(`${PICKUP_LOCATIONS_API_URL}/${id}`, {
        headers: getAuthHeaders(),
    });
    return res.data;
}